import { post } from '../Services/http';
import { catchError } from './Error.action';

export const STOCK_PRODUCTLIST = "STOCK_PRODUCTLIST"
export const STOCK_ERROR = "STOCK_ERROR"

export const setArticleList = (articleList) => (dispatch, getState) => {
    return post('/api/OnHand', articleList)
        .then(response => response.json())
        .then(data => dispatch(setArticleArray(data)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const loadError = error => ({
    type: STOCK_ERROR,
    payload: {
        error,
    }
})

export const setArticleArray = data => ({
    type: STOCK_PRODUCTLIST,
    payload: {
        articlesList: data,
    },
})
